module.exports = [{
      plugin: require('/home/runner/work/Edpuzzle-Web/Edpuzzle-Web/src/frontend/blog/node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-GSG4WLK3HR"],"gtagConfig":{"anonymize_ip":true},"pluginConfig":{}},
    },{
      plugin: require('/home/runner/work/Edpuzzle-Web/Edpuzzle-Web/src/frontend/blog/node_modules/gatsby-plugin-twitter/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
